module.exports = __webpack_public_path__ + "img/learning-fuze.51e93708.png";